export const iconAuto = {
    width: "auto",
    height: "auto",
    padding: 1,
    marginRight: 3,
    fontSize: "0.85rem",
  };
  
  export const closeIcon = {
    ...iconAuto,
    margin: 0,
    fontSize: 12,
  };